export default __webpack_public_path__ + "static/media/send.61bf7fb0.svg";